var _path, _path2, _circle, _circle2, _path3, _rect, _rect2, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDestinationbig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 35,
    viewBox: "0 0 28 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 12.1222C25 15.0034 23.2465 18.5725 21.3333 22.4951C18.8085 27.6718 15.788 33.037 14 34.0205C12.1659 32.6753 9.2133 27.7184 6.66667 22.4951C4.84955 18.768 3 14.9053 3 12.1222C3 5.43862 7.92487 0.0205078 14 0.0205078C20.0751 0.0205078 25 5.43862 25 12.1222Z",
    fill: "#254E9C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 12.1222C25 15.0034 23.2465 18.5725 21.3333 22.4951C18.8085 27.6718 15.788 33.037 14 34.0205C12.1659 32.6753 9.2133 27.7184 6.66667 22.4951C4.84955 18.768 3 14.9053 3 12.1222C3 5.43862 7.92487 0.0205078 14 0.0205078C20.0751 0.0205078 25 5.43862 25 12.1222Z",
    fill: "#254E9C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14.0205,
    r: 13,
    fill: "white",
    stroke: "#254E9C",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14.0205,
    r: 13,
    fill: "white",
    stroke: "#254E9C",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2325 11.4234V15.8878C17.2325 16.8026 17.2325 17.26 17.0723 17.6094C16.9313 17.9167 16.7064 18.1666 16.4298 18.3231C16.1154 18.5012 15.7038 18.5012 14.8805 18.5012H11.2545C10.4312 18.5012 10.0196 18.5012 9.70511 18.3231C9.42852 18.1666 9.20363 17.9167 9.0627 17.6094C8.90248 17.26 8.90248 16.8026 8.90248 15.8878V11.4234M8.95148 8.70117H17.1835C17.4579 8.70117 17.5951 8.70117 17.6999 8.76051C17.7921 8.81271 17.8671 8.896 17.9141 8.99844C17.9675 9.11491 17.9675 9.26737 17.9675 9.57228V10.5523C17.9675 10.8572 17.9675 11.0097 17.9141 11.1261C17.8671 11.2286 17.7921 11.3119 17.6999 11.3641C17.5951 11.4234 17.4579 11.4234 17.1835 11.4234H8.95148C8.67705 11.4234 8.53984 11.4234 8.43503 11.3641C8.34283 11.3119 8.26787 11.2286 8.22089 11.1261C8.16748 11.0097 8.16748 10.8572 8.16748 10.5523V9.57228C8.16748 9.26737 8.16748 9.11491 8.22089 8.99844C8.26787 8.896 8.34283 8.81271 8.43503 8.76051C8.53984 8.70117 8.67705 8.70117 8.95148 8.70117ZM11.8915 13.3289H14.2435C14.5179 13.3289 14.6551 13.3289 14.7599 13.3883C14.8521 13.4405 14.9271 13.5238 14.9741 13.6262C15.0275 13.7427 15.0275 13.8951 15.0275 14.2001V14.6356C15.0275 14.9405 15.0275 15.093 14.9741 15.2095C14.9271 15.3119 14.8521 15.3952 14.7599 15.4474C14.6551 15.5067 14.5179 15.5067 14.2435 15.5067H11.8915C11.6171 15.5067 11.4798 15.5067 11.375 15.4474C11.2828 15.3952 11.2079 15.3119 11.1609 15.2095C11.1075 15.093 11.1075 14.9405 11.1075 14.6356V14.2001C11.1075 13.8951 11.1075 13.7427 11.1609 13.6262C11.2079 13.5238 11.2828 13.4405 11.375 13.3883C11.4798 13.3289 11.6171 13.3289 11.8915 13.3289Z",
    stroke: "#254E9C",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.05,
    y: 7.30117,
    width: 4.9,
    height: 4.9,
    rx: 2.45,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.05,
    y: 7.30117,
    width: 4.9,
    height: 4.9,
    rx: 2.45,
    stroke: "#254E9C",
    strokeWidth: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7899 8.95117L16.87 10.8712L16 10.0012",
    stroke: "#254E9C",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDestinationbig);
export default __webpack_public_path__ + "static/media/destination big.cb1e254441c9febe5727288b20ee646e.svg";
export { ForwardRef as ReactComponent };